// @flow
import React from 'react';

import { BaseHeading } from './BaseHeading';

export const StyledH3 = ({ text, inline = false }) => (
  <BaseHeading as="h3" inline={inline} text={text} />
);
